import { axiosGet } from '../../axios/axios.js'
import { convertMSToDHMS } from '../../components/helpers.js'

export const queue = {
  data: function () {
    return {
      upBtnDisabled: true,
      downBtnDisabled: true,
      removeBtnDisabled: true,

      selectedRequest: null,
      brigadeRequestsTotalMessage: null
    }
  },
  watch: {
    brigadeRequests: {
      handler: function (value) {
        this.calculateTotalMessage(value)
      },
      immediate: true
    }
  },
  methods: {
    // default
    onQueueChange: function () {
    },
    onRequestSelected: function (selectedRequest, selected = true) {
      this.selectedRequest = selected ? selectedRequest : null
      this.updateButtons()
    },
    updateButtons: function () {
      const selectedRequest = this.selectedRequest
      if (!selectedRequest) {
        this.upBtnDisabled = true
        this.downBtnDisabled = true
        this.removeBtnDisabled = true
        return
      }

      const index = this.brigadeRequests.findIndex(r => {
        return r.id === selectedRequest.id
      })
      this.upBtnDisabled = !!(selectedRequest.active || index === 0 || this.brigadeRequests[index - 1].active)
      this.downBtnDisabled = !!(selectedRequest.active || index === this.brigadeRequests.length - 1)
      this.removeBtnDisabled = !!(selectedRequest.active || selectedRequest.target)

      this.updateAdditionalButtons()
    },
    // default
    updateAdditionalButtons: function () {
    },
    moveRequestInQueue: function (up = true) {
      const request = this.selectedRequest
      if (request && !request.active) {
        const index = this.brigadeRequests.findIndex(r => {
          return r.id === request.id
        })
        // eslint-disable-next-line no-mixed-operators
        if (up && !(index === 0 || this.brigadeRequests[index - 1].active) || !up && index !== this.brigadeRequests.length - 1) {
          const swapIndex = up ? index - 1 : index + 1
          this.$set(this.brigadeRequests, index, this.brigadeRequests[swapIndex])
          this.$set(this.brigadeRequests, swapIndex, request)
          this.recalculateBrigadeQueue()
          // this.updateButtons()
        }
      }
    },
    removeRequestFromQueue: function () {
      const request = this.selectedRequest
      this.selectedRequest = null
      if (request && !request.active && !request.target) {
        this.brigadeRequests = this.brigadeRequests.filter(r => r.id !== request.id)
        this.recalculateBrigadeQueue()
        // this.updateButtons()
      }
    },
    recalculateBrigadeQueue: function () {
      const readyToUseRequestDoc = this.request == null || (!!this.request.bpStateId && this.request.bpStateId !== 'BS0') // TODO
      const serviceName = readyToUseRequestDoc ? 'calculateQueue' : 'calculatePotentialQueue'

      const currentRequestsIds = []
      const requests = this.brigadeRequests
      let targetRequestIndex
      requests.forEach((request, index) => {
        if (!request.active) {
          if (!readyToUseRequestDoc && request.target) {
            targetRequestIndex = index
          } else {
            currentRequestsIds.push(request.id)
          }
        } else if (readyToUseRequestDoc && request.target) {
          currentRequestsIds.push(request.id)
        }
      })

      const params = new URLSearchParams()
      params.set('id', this.brigade.brigadeId)
      params.set('autoAssign', false)
      params.set('ignoreEndWorkTime', true)
      params.set('requests', currentRequestsIds.join(','))
      if (!readyToUseRequestDoc) {
        const workTypesIds = []
        this.request.workTypes.forEach(workType => workTypesIds.push(workType.id))

        params.set('position', targetRequestIndex)
        params.set('typeId', this.request.requestType)
        params.set('priority', this.request.requestPriority)
        params.set('workTypes', JSON.stringify(workTypesIds))
        params.set('objectId', this.request.serviceObject.id) // TODO append ???
      }

      axiosGet({
        url: '/service/delta/brigade/' + serviceName + '?' + params.toString(),
        onSuccess: (response) => {
          const requestsMap = response.data
          for (let i = 0; i < requests.length; i++) {
            const request = requests[i]
            const requestData = requestsMap[request.target ? -1 : request.id]
            if (requestData) {
              Object.assign(request, requestData)
            }
          }
          this.calculateTotalMessage(this.brigadeRequests)

          this.brigade.$_customOrder = {
            requestsIds: currentRequestsIds,
            targetRequestIndex: targetRequestIndex
          } // Это станет доступно и в родительском компоненте, т.к. событие о выборе бригады уже отправлено
          // TODO что еще нужно обновить ???

          this.updateButtons()
          this.onQueueChange()
        },
        onFailure: (response) => {
          this.$q.notify({
            type: 'negative',
            message: 'Ошибка перерасчета очереди заданий бригады',
            progress: true,
            timeout: 8000
          })

          this.updateButtons()
        },
        msgTarget: this
      })
    },
    calculateTotalMessage: function (requests) {
      let totalTravelTime = 0
      let totalTravelDistance = 0
      let totalExecutionDuration = 0
      for (let i = 0; i < requests.length; i++) {
        const request = requests[i]
        if (request.travelTime) {
          totalTravelTime += request.travelTime
        }
        if (request.travelDistance) {
          totalTravelDistance += request.travelDistance
        }
        totalExecutionDuration += request.executionDuration
      }
      this.brigadeRequestsTotalMessage = '<b>Время на перемещение:</b> ' + convertMSToDHMS(totalTravelTime) + //
        '  <b>Время на выполнение: </b> ' + convertMSToDHMS(totalExecutionDuration) + ', <b>Расстояние: </b>' + (totalTravelDistance / 1000).toFixed(1) + 'км'
    }
  }
}
